import { useState } from "react";
import GetPosts from "./GetPosts";

interface Props {
  currentSite: Page.Site;
  relatedToSection?: string;
  title: string | null;
  all: boolean;
  label: Record<string, any>;
}

export default function PostsPagination({ currentSite, relatedToSection, title, all, label }: Props) {
  const [page, setPage] = useState(1);

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  return (
    <div>
      <GetPosts
        currentSite={currentSite}
        relatedToSection={relatedToSection}
        title={title}
        all={all}
        page={page}
        label={label}
        getPostsByPage={handlePageChange}
      />
    </div>
  );
}